var _style, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamp01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#2958A8;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 24,
    height: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14.4,
    y: 2.5,
    transform: "matrix(0.9093 -0.4162 0.4162 0.9093 -3.5809 7.2829)",
    className: "st1",
    width: 1,
    height: 18.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -0.1,
    y: 11.4,
    transform: "matrix(0.4161 -0.9093 0.9093 0.4161 -5.3641 15.3546)",
    className: "st1",
    width: 18.7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.7,
    y: 19.8,
    className: "st1",
    width: 20.7,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.4,20.7H8.9v-2.6c0-1.8,1.4-3.2,3.2-3.2c1.8,0,3.2,1.4,3.2,3.2V20.7z M9.9,19.7h4.4v-1.6 c0-1.2-1-2.2-2.2-2.2c-1.3,0-2.2,1-2.2,2.2V19.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 19.4,
    y: 18.2,
    transform: "matrix(0.3378 -0.9412 0.9412 0.3378 -3.6421 32.3007)",
    className: "st1",
    width: 3.4,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.8,
    y: 17.1,
    transform: "matrix(0.9414 -0.3374 0.3374 0.9414 -6.1462 2.2027)",
    className: "st1",
    width: 1,
    height: 3.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.6,19.1c-0.2,0-0.4,0-0.4,0l0.1-1c0,0,2,0.2,3.2-1l0.7,0.7C6,18.9,4.3,19.1,3.6,19.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20,19.1c-1.3,0-2.5-0.7-2.5-0.7l0.5-0.9c0,0,1.8,1,3.1,0.3l0.5,0.9C21,19,20.5,19.1,20,19.1z"
  })))));
}
export default SvgCamp01;